<template>
	<div class="active-campaign">
		<Titlebar title="Current Campaign" />
		<!-- Loading state -->
		<Loading v-if="!campaign && !status" />
		<!-- Has active campaign -->
		<div class="cards" v-else-if="status === 200">
			<Campaign :campaign="campaign" class="campaign" :hide="['view']" />
			<Submissions
				:campaign="campaign"
				ref="submissions"
				@refresh="onSubmissionsRefresh"
			/>
			<Shortlist
				:campaign="campaign"
				ref="shortlist"
				@refresh="onShortlistRefresh"
				@progress="onRoundProgress"
			/>
		</div>
		<!-- 404 state -->
		<Card v-else-if="status === 404">
			<h2>No campaign running!</h2>
			<p v-if="isAdmin">
				<router-link :to="{ name: 'Create Campaign' }"
					>Create a new campaign</router-link
				>
				or
				<router-link :to="{ name: 'Manage Campaigns' }"
					>activate an existing one</router-link
				>
				to get started.
			</p>
		</Card>
		<!-- Default error state -->
		<Card v-else>
			<h2>Something went wrong, please try again.</h2>
		</Card>
	</div>
</template>

<script>
import { mapActions } from 'vuex'
import Card from '@/components/shared/Card'
import Loading from '@/components/shared/Loading'
import Titlebar from '@/components/admin/Titlebar'
import Campaign from '@/components/admin/Campaign'
import Submissions from '@/components/admin/Submissions'
import Shortlist from '@/components/admin/Shortlist'

const anyChange = (keys, obj = {}, prevObj = {}) => {
	return keys.some(
		key =>
			obj[key] !== undefined &&
			prevObj[key] !== undefined &&
			obj[key] !== prevObj[key]
	)
}

export default {
	name: 'active-campaign',
	data() {
		return {
			campaign: null,
			status: 0
		}
	},
	computed: {
		isAdmin() {
			return this.$store.getters['auth/isAdmin']
		}
	},
	methods: {
		...mapActions('api', ['get']),
		async getActiveCampaign() {
			// Reset error
			this.status = 0
			// Load active campaign
			try {
				const endpoint = '/campaigns/active'
				const res = await this.get({ endpoint })
				this.campaign = await res.json()
				this.status = res.status
			} catch (err) {
				this.status = err.status || 500
			}
		},
		onSubmissionsRefresh({ update = false }) {
			if (this.$refs.shortlist && update) this.$refs.shortlist.refresh()
		},
		onShortlistRefresh({ update = false }) {
			if (this.$refs.submissions && update) this.$refs.submissions.refresh()
		},
		async onRoundProgress({ round } = {}) {
			await this.getActiveCampaign()

			const query = { ...this.$route.query }
			if (query.round) query.round = round
			if (query.round_lt) query.round_lt = round

			if (anyChange(['round', 'round_lt'], query, this.$route.query)) {
				this.$router.replace({ path: this.$route.path, query })
			}
		}
	},
	created() {
		this.getActiveCampaign()
	},
	components: {
		Loading,
		Titlebar,
		Campaign,
		Submissions,
		Shortlist,
		Card
	}
}
</script>

<style lang="scss" scoped>
.cards > :not(:last-child) {
	margin-bottom: 3rem;
}
</style>
